import {
  ANDERSEN_AUDIO_FILES,
  AUDIO_FILES,
  HAPPY_BIRTH_AUDIO_FILE,
  SMILE_AUDIO_FILES,
  SMILE_TYPE,
  WEDDING_AUDIO_FILE
} from '@/common/constants/ConstCode';

export default {
  setTemplates(state, list) {
    state.templateList = [{ templateNo: null, name: '직접입력', content: '직접입력' }, ...list] || [];
  },
  setBusinessList(state, list = []) {
    state.businessList = list;
  },
  setTargetNo(state, targetNo = null) {
    state.targetNo = targetNo;
  },
  setDynamicLink(state, dynamicLink = '') {
    state.dynamicLink = dynamicLink;
  },
  setEnum(state, data) {
    state.enum = data || '';
  },

  // Cry (안데르센 제외) bgm
  setAudio(state, data) {
    if (data) {
      state.audio = data;
      return;
    }
    const randomIndex = Math.floor(Math.random() * AUDIO_FILES.length);
    state.audio = AUDIO_FILES[randomIndex];
    state.muted = false;
  },

  setSmileAudio(state, category) {
    switch (category) {
      case SMILE_TYPE.WEDDING.key:
        state.audio = WEDDING_AUDIO_FILE;
        state.muted = false;
        return;
      case SMILE_TYPE.HAPPY_BIRTH.key:
        state.audio = HAPPY_BIRTH_AUDIO_FILE;
        state.muted = false;
        return;
      default:
        const randomIndex = Math.floor(Math.random() * SMILE_AUDIO_FILES.length);
        state.audio = SMILE_AUDIO_FILES[randomIndex];
        state.muted = false;
    }
  },

  setAndersenAudio(state, data) {
    if (data) {
      state.audio = data;
      return;
    }
    const randomIndex = Math.floor(Math.random() * ANDERSEN_AUDIO_FILES.length);
    state.muted = false;
    state.audio = ANDERSEN_AUDIO_FILES[randomIndex];
  },

  // bgm 끄기
  initAudio(state) {
    state.audio = null;
    state.muted = true;
  },
  setAudioPlayer(state, audioPlayer) {
    state.audioPlayer = audioPlayer;
  },
  setMuted(state, muted) {
    console.log('muted', muted)
    if (muted !== undefined && muted !== null) {
      state.muted = muted;
      return;
    }
    state.muted = !state.muted;
  },
  setBibleList(state, list) {
    state.bibleList = list || [];
  },
  setFeatureFlags(state, flags) {
    state.featureFlags = flags || {};
    state.featureFlagsLoaded = true;
  }
};
